import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDefaultAvatar = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 20,
			fill: "white",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.9974 11.6641C17.8141 11.6641 16.0391 13.4391 16.0391 15.6224C16.0391 17.7641 17.7141 19.4974 19.8974 19.5724C19.9641 19.5641 20.0307 19.5641 20.0807 19.5724C20.0974 19.5724 20.1057 19.5724 20.1224 19.5724C20.1307 19.5724 20.1307 19.5724 20.1391 19.5724C22.2724 19.4974 23.9474 17.7641 23.9557 15.6224C23.9557 13.4391 22.1807 11.6641 19.9974 11.6641Z",
			fill: "#6F767E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.2328 21.7953C21.9078 20.2453 18.1161 20.2453 15.7745 21.7953C14.7161 22.5036 14.1328 23.462 14.1328 24.487C14.1328 25.512 14.7161 26.462 15.7661 27.162C16.9328 27.9453 18.4661 28.337 19.9995 28.337C21.5328 28.337 23.0661 27.9453 24.2328 27.162C25.2828 26.4536 25.8661 25.5036 25.8661 24.4703C25.8578 23.4453 25.2828 22.4953 24.2328 21.7953Z",
			fill: "#6F767E"
		})
	]
});
const ForwardRef = forwardRef(SvgDefaultAvatar);
export default ForwardRef;
